var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"about"}},[_c('div',{staticClass:"title"},[_vm._v("关于我们")]),_c('div',{staticClass:"title1"},[_vm._v("ABOUT US")]),_c('div',{staticClass:"about1"},[_vm._v(_vm._s(_vm.about))])])
}
var staticRenderFns = []

export { render, staticRenderFns }